import { CurrencyCodesEnum } from './currency-codes';
import { CompanyCodesEnum } from './company-codes';
const CurrencyToCompanyCodesObj = {};

CurrencyToCompanyCodesObj[CurrencyCodesEnum.IDR] = [`${CompanyCodesEnum.SDAM}`, `${CompanyCodesEnum.SRK}`, `${CompanyCodesEnum.BTR}`];
CurrencyToCompanyCodesObj[CurrencyCodesEnum.USD] = [`${CompanyCodesEnum.AVS}`, `${CompanyCodesEnum.SRPL}`, `${CompanyCodesEnum.PRPL}`];

export const CurrencyToCompanyCodes = Object.freeze(CurrencyToCompanyCodesObj);